import React, { useContext } from 'react';

//components
import WidgetButton from './WidgetButton/WidgetButton';

//enums
import { WidgetType } from  '@/interfaces/widgetPanel';

import { ListContext } from '@/context/ListContext';



const RSSWidget = () => {

    const {listId, appGuid, isMainMenu} = useContext(ListContext)

    return (
        <div className="widget-panel-item">
            <WidgetButton type={WidgetType.RSS} href={`/a/${appGuid}/Content?parentId=${listId}&contentType=Rss&position=${isMainMenu ? 'end' : 'start'}`} />
        </div>
    )
}
export default RSSWidget